// Author liang gang qiang
// Date 2021-11-25 16:25:20

import * as model from "@/model/mintalMes/prd/MintalMesPrdCraftEnergyConfigModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.MintalMesPrdCraftEnergyConfig(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_MINTALMES_PRD_URL,
    })
    .buildStore()
